export default {
  title: 'list shipping methods',
  search:'search ...',
  id: 'id',
  nameFa : 'name fa',
  nameEn : 'name en',
  status: 'status',
  statusActive: 'active',
  statusInActive: 'inactive',
  loading:'loading ... ',
  operating:'operating',
  empty:'list is empty',
  next:'Next',
  previous:'Previous',
  success:'success',
  btnCreate:'Add',
  shippingCost:'shipping cost',
  ErrorRetrievingInformation:'Error retrieving information',
  deleteConfirm:'Are you sure you want to delete this shipping method?'
}
